/**
 * Collection Chat Widget — Inline embedded chat for collection pages
 * Connects to Projektberater V3 Worker API.
 * Malermeister Thomas berät direkt auf der Kategorie-Seite.
 */
(function () {
  'use strict';

  // ─── Container lookup ────────────────────────────────────────────
  var container = document.querySelector('.fb-collection-chat');
  if (!container) return;

  // ─── Data attributes ─────────────────────────────────────────────
  var apiEndpoint = container.getAttribute('data-api-endpoint') || '';
  var category = container.getAttribute('data-category') || 'auto';
  var collectionHandle = container.getAttribute('data-collection-handle') || '';
  var collectionTitle = container.getAttribute('data-collection-title') || 'dieser Kategorie';

  // ─── State ────────────────────────────────────────────────────────
  var dialogHistory = [];
  var isLoading = false;

  // ─── Example questions per category ──────────────────────────────
  var EXAMPLE_QUESTIONS = {
    'Fassaden': [
      'Welchen Putz brauche ich für meine Fassade?',
      'Was ist der Unterschied zwischen Kratz- und Scheibenputz?',
      'Wie viel Material brauche ich für meine Fläche?',
      'Welche Grundierung muss ich verwenden?',
      'Kann ich bei kaltem Wetter verputzen?'
    ],
    'Innenfarben': [
      'Welche Farbe eignet sich für Küche und Bad?',
      'Wie viel Farbe brauche ich für meinen Raum?',
      'Matt oder seidenglänzend – was ist besser?',
      'Brauche ich eine Grundierung auf Raufaser?',
      'Welche Farbe deckt am besten?'
    ],
    'Malervlies': [
      'Welches Vlies brauche ich für meinen Untergrund?',
      'Wie verarbeite ich Malervlies richtig?',
      'Welchen Kleber soll ich verwenden?',
      'Kann ich Vlies auf Raufaser kleben?'
    ],
    'Holz': [
      'Welcher Lack eignet sich für Holz im Außenbereich?',
      'Muss ich Holz vor dem Lackieren grundieren?',
      'Welcher Lack ist für Kindermöbel geeignet?',
      'Wie behandle ich verwittertes Holz?'
    ],
    'Kreativtechnik': [
      'Welche Effektfarben bietet ihr an?',
      'Wie erzeuge ich eine Betonoptik?',
      'Welche Spachteltechniken gibt es?',
      'Kann ich Effektfarben selbst auftragen?'
    ],
    'auto': [
      'Welches Produkt passt zu meinem Projekt?',
      'Ich brauche eine Beratung zu Farben',
      'Welche Grundierung brauche ich?',
      'Was empfiehlst du für Anfänger?'
    ]
  };

  // ─── Build UI ─────────────────────────────────────────────────────
  var widgetEl = document.createElement('div');
  widgetEl.className = 'ccw-widget';

  // Header
  var headerEl = document.createElement('div');
  headerEl.className = 'ccw-header';

  var avatarEl = document.createElement('img');
  avatarEl.className = 'ccw-header__avatar';
  avatarEl.src = 'https://cdn.shopify.com/s/files/1/0606/1821/1516/files/thomas-malermeister.jpg?v=1772176011';
  avatarEl.alt = 'Malermeister Thomas';
  avatarEl.width = 40;
  avatarEl.height = 40;
  avatarEl.loading = 'lazy';

  var headerTextEl = document.createElement('div');
  headerTextEl.className = 'ccw-header__text';

  var headerTitleEl = document.createElement('span');
  headerTitleEl.className = 'ccw-header__title';
  headerTitleEl.textContent = 'Frag Malermeister Thomas';

  var headerSubEl = document.createElement('span');
  headerSubEl.className = 'ccw-header__subtitle';
  headerSubEl.textContent = 'Persönliche Beratung';

  headerTextEl.appendChild(headerTitleEl);
  headerTextEl.appendChild(headerSubEl);
  headerEl.appendChild(avatarEl);
  headerEl.appendChild(headerTextEl);

  // Messages area
  var messagesEl = document.createElement('div');
  messagesEl.className = 'ccw-messages';

  // Example chips area
  var chipsEl = document.createElement('div');
  chipsEl.className = 'ccw-chips';

  // Input area
  var inputAreaEl = document.createElement('div');
  inputAreaEl.className = 'ccw-input-area';

  var inputEl = document.createElement('input');
  inputEl.className = 'ccw-input';
  inputEl.type = 'text';
  inputEl.placeholder = 'Deine Frage an Thomas...';
  inputEl.autocomplete = 'off';

  var sendBtnEl = document.createElement('button');
  sendBtnEl.className = 'ccw-send-btn';
  sendBtnEl.type = 'button';
  sendBtnEl.disabled = true;
  sendBtnEl.setAttribute('aria-label', 'Nachricht senden');
  sendBtnEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>';

  inputAreaEl.appendChild(inputEl);
  inputAreaEl.appendChild(sendBtnEl);

  // Assemble widget
  widgetEl.appendChild(headerEl);
  widgetEl.appendChild(messagesEl);
  widgetEl.appendChild(chipsEl);
  widgetEl.appendChild(inputAreaEl);
  container.appendChild(widgetEl);

  // ─── Initial content ──────────────────────────────────────────────
  addMessage(
    'Hallo! Ich bin Thomas, dein Malermeister. Wie kann ich dir bei ' + escapeHtml(collectionTitle) + ' helfen?',
    'bot'
  );
  renderChips();

  // ─── Event listeners ──────────────────────────────────────────────
  inputEl.addEventListener('input', function () {
    sendBtnEl.disabled = !inputEl.value.trim();
  });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      var text = inputEl.value.trim();
      if (text && !isLoading) {
        sendUserMessage(text);
      }
    }
  });

  sendBtnEl.addEventListener('click', function () {
    var text = inputEl.value.trim();
    if (text && !isLoading) {
      sendUserMessage(text);
    }
  });

  chipsEl.addEventListener('click', function (e) {
    var chip = e.target.closest('.ccw-chip');
    if (chip && !isLoading) {
      sendUserMessage(chip.textContent.trim());
    }
  });

  // ─── Render helpers ───────────────────────────────────────────────

  /**
   * Render example question chips for the current category.
   */
  function renderChips() {
    chipsEl.innerHTML = '';
    var questions = EXAMPLE_QUESTIONS[category] || EXAMPLE_QUESTIONS['auto'];

    for (var i = 0; i < questions.length; i++) {
      var btn = document.createElement('button');
      btn.className = 'ccw-chip';
      btn.type = 'button';
      btn.textContent = questions[i];
      chipsEl.appendChild(btn);
    }
  }

  /**
   * Add a message bubble to the messages area.
   * @param {string} text - Message text (will be formatted).
   * @param {string} role - "user" or "bot".
   * @returns {HTMLElement} The message container element.
   */
  function addMessage(text, role) {
    var msgDiv = document.createElement('div');
    msgDiv.className = 'ccw-msg ccw-msg--' + (role === 'user' ? 'user' : 'bot');

    if (role !== 'user') {
      var msgAvatar = document.createElement('img');
      msgAvatar.className = 'ccw-msg__avatar';
      msgAvatar.src = 'https://cdn.shopify.com/s/files/1/0606/1821/1516/files/thomas-malermeister.jpg?v=1772176011';
      msgAvatar.alt = '';
      msgAvatar.width = 28;
      msgAvatar.height = 28;
      msgAvatar.loading = 'lazy';
      msgDiv.appendChild(msgAvatar);
    }

    var bubble = document.createElement('div');
    bubble.className = 'ccw-msg__bubble';
    bubble.innerHTML = formatText(text);

    msgDiv.appendChild(bubble);
    messagesEl.appendChild(msgDiv);
    scrollToBottom();
    return msgDiv;
  }

  /**
   * Show clickable option buttons (for question-type responses).
   * @param {string[]} options - Array of option labels.
   */
  function addOptions(options) {
    if (!options || options.length === 0) return;

    var optionsDiv = document.createElement('div');
    optionsDiv.className = 'ccw-options';

    for (var i = 0; i < options.length; i++) {
      (function (optionText) {
        var btn = document.createElement('button');
        btn.className = 'ccw-option-btn';
        btn.type = 'button';
        btn.textContent = optionText;
        btn.addEventListener('click', function () {
          optionsDiv.remove();
          if (!isLoading) {
            sendUserMessage(optionText);
          }
        });
        optionsDiv.appendChild(btn);
      })(options[i]);
    }

    messagesEl.appendChild(optionsDiv);
    scrollToBottom();
  }

  /**
   * Show product recommendation cards.
   * @param {Array} products - Array of product objects with handle, name/title, reason, pros.
   */
  function addProductCards(products) {
    if (!products || products.length === 0) return;

    var cardsDiv = document.createElement('div');
    cardsDiv.className = 'ccw-products';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var productTitle = p.name || p.title || '';

      var card = document.createElement('a');
      card.className = 'ccw-product-card';
      card.href = '/products/' + encodeURIComponent(p.handle);

      var cardTitle = document.createElement('span');
      cardTitle.className = 'ccw-product-card__title';
      cardTitle.textContent = productTitle;
      card.appendChild(cardTitle);

      if (p.reason) {
        var cardReason = document.createElement('span');
        cardReason.className = 'ccw-product-card__reason';
        cardReason.textContent = p.reason;
        card.appendChild(cardReason);
      }

      if (p.pros && p.pros.length > 0) {
        var prosList = document.createElement('ul');
        prosList.className = 'ccw-product-card__pros';
        for (var j = 0; j < p.pros.length; j++) {
          var li = document.createElement('li');
          li.textContent = p.pros[j];
          prosList.appendChild(li);
        }
        card.appendChild(prosList);
      }

      cardsDiv.appendChild(card);
    }

    messagesEl.appendChild(cardsDiv);
    scrollToBottom();
  }

  /**
   * Show the typing indicator (three bouncing dots).
   */
  function addTypingIndicator() {
    var msgDiv = document.createElement('div');
    msgDiv.className = 'ccw-msg ccw-msg--bot ccw-msg--typing';
    msgDiv.id = 'ccw-typing';

    var msgAvatar = document.createElement('img');
    msgAvatar.className = 'ccw-msg__avatar';
    msgAvatar.src = 'https://cdn.shopify.com/s/files/1/0606/1821/1516/files/thomas-malermeister.jpg?v=1772176011';
    msgAvatar.alt = '';
    msgAvatar.width = 28;
    msgAvatar.height = 28;
    msgDiv.appendChild(msgAvatar);

    var bubble = document.createElement('div');
    bubble.className = 'ccw-msg__bubble ccw-typing';
    bubble.innerHTML = '<span class="ccw-dot"></span><span class="ccw-dot"></span><span class="ccw-dot"></span>';

    msgDiv.appendChild(bubble);
    messagesEl.appendChild(msgDiv);
    scrollToBottom();
  }

  /**
   * Remove the typing indicator.
   */
  function removeTypingIndicator() {
    var el = document.getElementById('ccw-typing');
    if (el) el.remove();
  }

  /**
   * Scroll the messages area to the bottom.
   */
  function scrollToBottom() {
    requestAnimationFrame(function () {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  }

  /**
   * Set loading state: disable/enable input and send button.
   * @param {boolean} loading
   */
  function setLoading(loading) {
    isLoading = loading;
    inputEl.disabled = loading;
    sendBtnEl.disabled = loading || !inputEl.value.trim();
    if (loading) {
      inputEl.setAttribute('placeholder', 'Thomas tippt...');
    } else {
      inputEl.setAttribute('placeholder', 'Deine Frage an Thomas...');
    }
  }

  // ─── Core messaging ───────────────────────────────────────────────

  /**
   * Handle a user message: display it, call the API, render response.
   * @param {string} text - The user's message text.
   */
  function sendUserMessage(text) {
    if (isLoading || !text) return;

    // Clear input
    inputEl.value = '';
    sendBtnEl.disabled = true;

    // Hide example chips after first message
    chipsEl.classList.add('ccw-chips--hidden');

    // Remove any remaining option buttons
    var oldOptions = messagesEl.querySelectorAll('.ccw-options');
    for (var i = 0; i < oldOptions.length; i++) {
      oldOptions[i].remove();
    }

    // Add user message bubble
    addMessage(text, 'user');

    // Add to dialog history
    dialogHistory.push({ role: 'user', content: text });

    // Show typing and call API
    setLoading(true);
    addTypingIndicator();

    callApi(text);
  }

  /**
   * Call the Shop Assistant API (Q&A mode, no guided discovery).
   * @param {string} text - The user question (already added to dialogHistory).
   */
  function callApi(text) {
    var payload = {
      page_type: 'collection',
      question: text,
      dialog_history: dialogHistory,
      collection_context: {
        handle: collectionHandle,
        title: collectionTitle
      }
    };

    fetch(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        removeTypingIndicator();
        handleApiResponse(data);
      })
      .catch(function (err) {
        removeTypingIndicator();
        addMessage(
          'Entschuldige, da ist gerade etwas schiefgelaufen. Versuche es bitte gleich nochmal.',
          'bot'
        );
        console.error('Collection Chat Widget error:', err);
      })
      .finally(function () {
        setLoading(false);
        inputEl.focus();
      });
  }

  /**
   * Handle the Shop Assistant API response.
   * @param {Object} data - The API response JSON.
   */
  function handleApiResponse(data) {
    if (!data) {
      addMessage('Entschuldige, ich konnte keine Antwort generieren.', 'bot');
      return;
    }

    if (data.type === 'error') {
      addMessage(
        data.error || 'Entschuldige, da ist etwas schiefgelaufen.',
        'bot'
      );
      return;
    }

    // Display the answer text
    var answerText = data.text || data.answer || 'Entschuldige, ich konnte keine Antwort generieren.';
    addMessage(answerText, 'bot');
    dialogHistory.push({ role: 'assistant', content: answerText });

    // Show clickable options if provided
    if (data.options && data.options.length > 0) {
      addOptions(data.options);
    }

    // Show related products as cards
    if (data.related_products && data.related_products.length > 0) {
      addProductCards(data.related_products);
    }
  }

  // ─── Text utilities ───────────────────────────────────────────────

  /**
   * Escape HTML to prevent XSS.
   * @param {string} text
   * @returns {string}
   */
  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Format text: convert **bold**, newlines to <br>.
   * Input is escaped first to prevent XSS.
   * @param {string} text
   * @returns {string}
   */
  function formatText(text) {
    if (!text) return '';
    var html = escapeHtml(text);
    // Bold: **text**
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Italic: *text*
    html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
    // Newlines
    html = html.replace(/\n/g, '<br>');
    return html;
  }
})();
